import React from 'react'
import { useTranslation } from 'react-i18next'

import { useChecklistForm, useChecklistFormActions } from '../../_form/ChecklistFormHandler'
import FlexGrid, { FlexCol } from '../../../../../components/structure/FlexGrid'
import { useIsTemplatesWorkspace } from '../../_helpers/templates'
import IconPicker from '../../../../../components/form/IconPicker'
import FormItem from '../../../../../components/form/FormItem'
import Textarea from '../../../../../components/form/Textarea'
import SectionsSeparator from './SectionsSeparator'

const TemplateSection = () => {
  const form = useChecklistForm()
  const { handleChange } = useChecklistFormActions()
  const isTemplates = useIsTemplatesWorkspace()
  const { t } = useTranslation('editChecklist')

  const commonProps = { handleChange, form, t }

  if (!isTemplates) return null

  return (
    <>
      <FlexGrid paddingGutter={0.5} align="flex-start" justify="flex-start" wrap>
        <FlexCol width="70%">
          <FormItem label={t('fieldsStep.description')} field="description" Input={Textarea} {...commonProps} />
        </FlexCol>
        <FlexCol width="30%">
          <FormItem label={t('fieldsStep.icon')} field="icon" Input={IconPicker} {...commonProps} />
        </FlexCol>
      </FlexGrid>
      <SectionsSeparator />
    </>
  )
}

export default TemplateSection
